
import { RespostaFinanceiro } from "app/types/pesquisa-orcamento/sub-consultas-notas-fiscais/Financeiro";
import globalMU from "globalMU";
import React from "react";

const estilosTabelas = require('../../../../../estilos/tabelas.module.scss').default

export type NotaFiscalFinanceiroProps = {
    dadosfincaneiro: RespostaFinanceiro[];
};

export const NotaFiscalFinanceiro = (props: NotaFiscalFinanceiroProps) => {

    const headerTabela = () => {
        const mapHeader = ["Filial", "Número", "Documento", "Valor", "Vencimento", "Pagamento", "Valor Pago", "Situação"]

        return mapHeader.map((nome) => <th key={nome}>{nome}</th>)
    }

    const itensTabela = (dado: RespostaFinanceiro) => {
        const mapBody = [
            dado.Filial, dado.Numero, dado.Documento, globalMU.formatarValorNumerico(dado.Valor, 2, true),
            globalMU.formatDate(dado.DataVencimento), globalMU.formatDate(dado.DataPagamento),
            globalMU.formatarValorNumerico(dado.ValorPago, 2, true), dado.Situacao
        ]

        return mapBody.map((nome, indice) => <td key={indice}>{nome}</td>)
    }


    const tabelaFinanceiro =
        <div className="_my-4">
            <table className={`_table _w-full _border-collapse ${estilosTabelas.tabela}`}>
                <thead>
                    <tr>
                        {headerTabela()}
                    </tr>
                </thead>
                <tbody>
                    {props.dadosfincaneiro.map((dado) => (
                        <tr key={`${dado.Filial}-${dado.Documento}-${dado.Numero}`}>
                            {itensTabela(dado)}
                        </tr>
                    ))}
                </tbody>
            </table>

        </div>


    return (
        <>
            {tabelaFinanceiro}
        </>
    )
}